(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.components = svs.components || {};
svs.components.sportinfo = svs.components.sportinfo || {};
svs.components.sportinfo.bigstat = svs.components.sportinfo.bigstat || {};

 })(window);